import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  updateMessage: ['messageText'],
  submitMessage: ['details'],
  submitAnswer: ['answer'],
  displayMessage: ['details'],
  displayFileMessage: ['details'],

  addUnreadMessage: [],
  clearUnreadMessages: [],

  clearMessages: [],
})
